import { render, staticRenderFns } from "./privateRumy.vue?vue&type=template&id=fd557922&scoped=true&"
import script from "./privateRumy.vue?vue&type=script&lang=ts&"
export * from "./privateRumy.vue?vue&type=script&lang=ts&"
import style0 from "./privateRumy.vue?vue&type=style&index=0&id=fd557922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd557922",
  null
  
)

export default component.exports